import { Toast } from '@bp/ui-components';
import * as Sentry from '@sentry/react';
import { AppLayoutContextProvider } from './contexts/AppLayoutContextProvider';
import { UserConfigProvider } from './contexts/StoreContext/UserConfigContext';
import { DataLoader } from './DataLoader';
import { PlanungAuthProvider } from './PlanungAuthProvider';
import { RequireAuth } from './RequireAuth';
import { RequireBackend } from './RequireBackend';
import { UrqlClientProvider } from './UrqlClientProvider';

export const App = Sentry.withProfiler(() => {
  return (
    <PlanungAuthProvider>
      <RequireAuth>
        <RequireBackend>
          <UrqlClientProvider>
            <UserConfigProvider>
              <AppLayoutContextProvider>
                <DataLoader />
              </AppLayoutContextProvider>
            </UserConfigProvider>
          </UrqlClientProvider>
        </RequireBackend>
        <Toast />
      </RequireAuth>
    </PlanungAuthProvider>
  );
});
